import { h } from "omi";

import { IconProps } from "@/wc/components";

export function ListIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} viewBox="0 0 20 20">
      <path
        d="M17.5 9.99935h-10m10-5h-10m10 9.99995h-10M4.16667 9.99935c0 .46025-.3731.83335-.83334.83335-.46023 0-.83333-.3731-.83333-.83335 0-.46024.3731-.83333.83333-.83333.46024 0 .83334.37309.83334.83333Zm0-5c0 .46024-.3731.83333-.83334.83333-.46023 0-.83333-.37309-.83333-.83333 0-.46024.3731-.83333.83333-.83333.46024 0 .83334.37309.83334.83333Zm0 9.99995c0 .4603-.3731.8334-.83334.8334-.46023 0-.83333-.3731-.83333-.8334 0-.4602.3731-.8333.83333-.8333.46024 0 .83334.3731.83334.8333Z"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
